// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"558":"1f86512e","4488":"1f86512e","9525":"1f86512e"}[chunkId] + ".chunk.css";
};